import { useTranslation } from "@/langs/useTranslation";

function ScheduleType({ data }) {
  const { t } = useTranslation("powerManagement");

  data.json = data.json || JSON.parse(data.taskScheduleJson || "{}");

  const dayStr =
    data.schedule_type === "weekly" || data.json.cycle_type === "weekly_days"
      ? t({ defaultMessage: "每周" })
      : t({ defaultMessage: "每日" });
  let cycleStr = "";
  if (data.json.cycle_type === "weekly_days") {
    cycleStr =
      t({ defaultMessage: "每{num}周" }, { num: data.json.cycle_value }) +
      " " +
      data.json.cycle_days?.map(d => t(`dialog.${d}Text`)).join("、");
  } else if(data.json.cycle_type === "daily") {
    cycleStr =
      data.json.cycle_value === "every"
        ? `${t("dialog.everyText")}${t("dialog.daysText")}`
        : t("dialog.everyWorkDays");
  } else {
    cycleStr =
      data.json.cycle_type === "every"
        ? t({ defaultMessage: "每{num}天" }, { num: data.json.cycle_value })
        : t("dialog.everyWorkDays");
  }

  return <>{dayStr + ": " + cycleStr}</>;
}

export default ScheduleType;
